export default __webpack_public_path__ + "src/images/packages/eco-karoo-lodge/b02aa0b89e6df18c313274b0040b8b29-5.png";